import type { Messages } from "./en";

/** Indonesian message catalog - key shape is enforced by Messages. */
export const id: Messages = {
    app: {
        name: "Flexv Coach",
    },
    nav: {
        group: {
            overview: "Ringkasan",
            schedule: "Jadwal & tugas",
            profile: "Profil saya",
            merchant: "Merchant",
        },
        dashboard: { label: "Dashboard", subtitle: "Ringkasan performa Anda" },
        assignments: { label: "Penugasan", subtitle: "Tabel + filter & aksi cepat" },
        affiliations: { label: "Afiliasi", subtitle: "Outlet tempat Anda bernaung" },
        sports: { label: "Olahraga", subtitle: "Olahraga yang Anda kuasai" },
        plan: { label: "Jadwal Coach", subtitle: "Tampilan kalender mingguan" },
        availability: { label: "Ketersediaan", subtitle: "Aturan ketersediaan mingguan" },
        contract: { label: "Kontrak", subtitle: "Detail kontrak dan penggajian" },
        pricing: { label: "Harga Layanan", subtitle: "Tarif untuk sesi Anda" },
        payroll: { label: "Payroll", subtitle: "Estimasi penghasilan bulanan" },
        invitations: { label: "Undangan", subtitle: "Permintaan klub yang menunggu Anda" },
        profile: { label: "Profil", subtitle: "Detail akun Anda" },
        section: "Menu",
        search: "Cari menu",
        clearSearch: "Hapus pencarian",
        noResults: "Menu tidak ditemukan",
        collapse: "Perkecil sidebar",
        expand: "Perluas sidebar",
    },
    header: {
        openMenu: "Buka menu",
        closeNavigation: "Tutup navigasi",
        userMenu: "Menu pengguna",
        helpCenter: "Pusat Bantuan",
        profile: "Profil",
        logout: "Keluar",
    },
    theme: {
        label: "Tema",
        system: "Sistem",
        light: "Terang",
        dark: "Gelap",
    },
    language: {
        label: "Bahasa",
        id: "Bahasa Indonesia",
        en: "English",
    },
    coach: {
        freelance: "Coach Freelance",
        inHouse: "Coach In-House",
    },
    assignments: {
        title: "Penugasan",
        subtitle: "Seluruh sesi yang ditugaskan kepada Anda, lengkap dengan aksi status.",
        loading: "Memuat penugasan...",
        loadFailed: "Penugasan gagal dimuat. Silakan coba lagi.",
        actionFailed: "Status gagal diperbarui. Silakan coba lagi.",
        unnamed: "Sesi",
        preset: { week: "Minggu ini", month: "30 hari ke depan" },
        filter: {
            title: "Filter",
            range: "Rentang tanggal",
            from: "Dari",
            to: "Sampai",
            outlet: "Outlet",
            status: "Status",
            allOutlets: "Semua outlet",
            allStatuses: "Semua status",
            upcomingOnly: "Mendatang saja",
            reset: "Reset",
            active: "Aktif",
        },
        listTitle: "Daftar penugasan",
        listCount: "{count} sesi",
        column: {
            date: "Tanggal & waktu",
            session: "Sesi",
            outlet: "Outlet",
            status: "Status",
            actions: "Aksi",
        },
        action: {
            confirmed: "Konfirmasi",
            completed: "Selesai",
            cancelled: "Batalkan",
        },
        empty: {
            title: "Penugasan tidak ditemukan",
            description: "Coba perlebar rentang tanggal atau bersihkan filternya.",
        },
    },
    affiliations: {
        title: "Afiliasi",
        subtitle: "Outlet dan perusahaan tempat Anda terdaftar sebagai coach.",
        loading: "Memuat afiliasi...",
        loadFailed: "Afiliasi gagal dimuat. Silakan coba lagi.",
        readOnlyNote:
            "Afiliasi dikelola oleh merchant. Pengajuan dari kedua belah pihak segera hadir.",
        primary: "Utama",
        type: "Jenis employment",
        scope: "Cakupan",
        scopeOutlet: "Outlet",
        scopeCompany: "Seluruh perusahaan",
        companyWide: "Seluruh perusahaan",
        verifiedNote: "Afiliasi aktif — Anda bisa dijadwalkan di outlet ini.",
        status: {
            active: "Aktif",
            pending_approval: "Menunggu persetujuan",
            rejected: "Ditolak",
            inactive: "Nonaktif",
            terminated: "Dihentikan",
        },
        empty: {
            title: "Belum ada afiliasi",
            description: "Begitu merchant mengafiliasikan Anda, datanya muncul di sini.",
        },
    },
    availability: {
        title: "Ketersediaan",
        subtitle: "Jendela mingguan kapan Anda bisa dijadwalkan mengajar.",
        loading: "Memuat ketersediaan...",
        loadFailed: "Ketersediaan gagal dimuat. Silakan coba lagi.",
        readOnlyNote: "Ketersediaan diatur oleh admin outlet — hubungi mereka bila ada yang perlu diubah.",
        summary: {
            totalHours: "Total jam",
            hoursPerWeek: "{h} jam/minggu",
            daysActive: "{n} hari aktif",
            windows: "{n} jendela",
        },
        effectiveFrom: "Berlaku mulai {date}",
        effectiveUntil: "s/d {date}",
        unavailable: "Tidak tersedia",
        closed: "Tutup",
        empty: {
            title: "Belum ada ketersediaan",
            description: "Minta admin outlet mengatur jadwal mingguan Anda.",
        },
    },
    sports: {
        title: "Olahraga",
        subtitle: "Kelola olahraga yang Anda ajar dan tentukan yang utama.",
        loading: "Memuat olahraga...",
        loadFailed: "Olahraga gagal dimuat. Silakan coba lagi.",
        actionFailed: "Perubahan gagal disimpan. Silakan coba lagi.",
        primary: "Utama",
        add: {
            title: "Tambah olahraga",
            subtitle: "Pilih dari katalog olahraga yang tersedia di Flexv.",
            sport: "Olahraga",
            owned: "Sudah ada di profil Anda",
            placeholder: "Pilih olahraga",
            submit: "Tambah",
            hint: "Pilih satu olahraga dari katalog, lalu tekan Tambah.",
            ready: "siap ditambahkan",
            emptyMaster: "Semua olahraga yang tersedia sudah ada di profil Anda.",
            },
            picker: {
                title: "Pilih olahraga",
                subtitle: "Semua olahraga dari master Flexv",
                search: "Cari olahraga...",
                noResult: "Tidak ada olahraga yang cocok dengan pencarian.",
                open: "Ketuk untuk melihat semua olahraga",
            },
            list: {
            title: "Olahraga Anda",
            added: "Ditampilkan di profil coach",
        },
        action: {
            setPrimary: "Jadikan utama",
            unsetPrimary: "Lepas utama",
            remove: "Hapus",
        },
        empty: {
            title: "Belum ada olahraga",
            description: "Tambahkan olahraga yang Anda kuasai agar merchant bisa mencocokkan.",
        },
    },
    plan: {
        title: "Jadwal Coach",
        subtitle: "Jadwal mengajar mingguan Anda",
        today: "Hari ini",
        thisWeek: "Minggu ini",
        prevWeek: "Minggu sebelumnya",
        nextWeek: "Minggu berikutnya",
        loading: "Memuat jadwal...",
        loadFailed: "Jadwal gagal dimuat. Silakan coba lagi.",
        actionFailed: "Status gagal diperbarui. Silakan coba lagi.",
        day: {
            off: "Libur",
            empty: "Tidak ada sesi terjadwal.",
            sessionCount: "{count} sesi",
        },
        summary: {
            sessions: "Sesi minggu ini",
            sessionsHint: "{count} sebagai lead coach",
            totalHours: "Total jam",
            totalHoursHint: "Jumlah seluruh jendela jadwal",
            completed: "Selesai",
            completedHint: "{count} masih terjadwal",
            busiestDay: "Hari tersibuk",
            busiestHint: "Tidak ada sesi pada rentang ini",
        },
        filter: {
            title: "Filter",
            outlet: "Outlet",
            status: "Status",
            allOutlets: "Semua outlet",
            allStatuses: "Semua status",
            reset: "Reset",
        },
        empty: {
            title: "Tidak ada sesi minggu ini",
            description: "Coba minggu lain atau bersihkan filternya.",
        },
    },
    dashboard: {
        greeting: "Halo, {name}",
        subtitle: "Performa coaching Anda",
        loading: "Memuat dashboard...",
        loadFailed: "Dashboard gagal dimuat. Silakan coba lagi.",
        unspecified: "Tanpa keterangan",
        range: {
            label: "Rentang dashboard",
            week: "Minggu ini",
            month: "Bulan ini",
        },
        stats: {
            sessions: "Jumlah sesi",
            teachingHours: "Jam mengajar",
            completionRate: "Tingkat penyelesaian",
            completionHint: "Sesi selesai dibanding sesi yang sudah diputuskan",
            rating: "Rating",
            ratingHint: "Rata-rata rating member",
            vsPrevious: "vs periode sebelumnya",
            noPrevious: "Tidak ada data di periode sebelumnya",
        },
        charts: {
            trend: {
                title: "Sesi per hari",
                subtitle: "Beban kerja harian pada rentang yang dipilih",
            },
            attendance: {
                title: "Rincian kehadiran",
                subtitle: "Status sesi pada periode ini",
            },
            outlets: { title: "Sesi per outlet" },
            sports: { title: "Sesi per olahraga" },
        },
        payroll: {
            title: "Estimasi payroll",
            subtitle: "Berdasarkan kontrak aktif Anda",
            disclaimer: "Hanya estimasi — payroll final diproses oleh merchant.",
            basis: "Dasar penggajian",
            eligibleSessions: "Sesi yang dihitung",
            eligibleHours: "Jam yang dihitung",
            note: {
                no_contract: "Belum ada kontrak aktif, jadi payroll belum bisa diestimasi.",
                rate_missing: "Kontrak belum memiliki tarif, jadi payroll belum bisa diestimasi.",
                basis_unknown:
                    "Dasar penggajian tidak dikenali, jadi payroll belum bisa diestimasi.",
            },
        },
        upcoming: {
            title: "Jadwal mendatang",
            subtitle: "Tugas terjadwal berikutnya",
            empty: "Belum ada jadwal mendatang",
            emptyDescription: "Penugasan baru dari merchant akan muncul di sini.",
            viewAll: "Lihat semua",
        },
        empty: {
            title: "Belum ada data",
            description: "Statistik muncul setelah Anda memiliki sesi pada periode ini.",
        },
    },
    profile: {
        about: "Tentang",
        contact: "Kontak",
        outlets: "Outlet",
        sports: "Olahraga",
        email: "Email",
        phone: "Telepon",
        joined: "Bergabung",
        primary: "Utama",
        rating: "Rating",
        noAffiliations: "Tidak ada afiliasi aktif.",
        unverifiedEmail: "Email belum diverifikasi. Sebagian fitur mungkin terbatas.",
        verifyNow: "Verifikasi sekarang",
        subtitle: "Siapa Anda sebagai coach — terlihat di semua outlet Anda.",
        edit: {
            open: "Ubah profil",
            title: "Ubah profil",
            subtitle: "Hanya tiga ini yang bisa diubah. Email & nama login tetap.",
            displayName: "Nama tampil",
            displayNamePlaceholder: "mis. Coach Andi",
            phone: "Telepon",
            phonePlaceholder: "+62 ...",
            bio: "Bio",
            bioPlaceholder: "Perkenalan singkat yang dilihat klien...",
            submit: "Simpan perubahan",
            cancel: "Batal",
            success: "Profil diperbarui.",
            phoneTaken: "Nomor telepon ini sudah dipakai akun lain.",
            failed: "Profil tidak dapat disimpan. Silakan coba lagi.",
        },
        stats: {
            sessions: "Sesi",
            hours: "Jam mengajar",
            outlets: "Outlet",
            rating: "Rating",
        },
    },
    invitations: {
        title: "Undangan Klub",
        subtitle: "Klub yang mengajak Anda bergabung. Hanya Anda yang memutuskan.",
        loading: "Memuat undangan...",
        loadFailed: "Undangan tidak dapat dimuat. Silakan coba lagi.",
        decideFailed: "Keputusan tidak dapat disimpan. Silakan coba lagi.",
        decidedByYou:
            "Permintaan ini diajukan oleh klub dan menunggu PERSETUJUAN ANDA — merchant tidak bisa menyetujukannya atas nama Anda.",
        companyWide: "Seluruh company (tanpa outlet tertentu)",
        employmentType: "Hubungan kerja",
        requestedAt: "Diajukan",
        awaitingYou: "Menunggu Anda",
        firstClubNote:
            "Klub pertama yang Anda terima menjadi klub asal; klub berikutnya tetap sekunder.",
        accept: "Terima",
        decline: "Tolak",
        processing: "Menyimpan...",
        empty: {
            title: "Belum ada undangan",
            description:
                "Bila sebuah klub mengundang Anda bergabung, permintaannya muncul di sini untuk Anda setujui.",
        },
    },
    pricing: {
        title: "Harga Layanan",
        subtitle: "Tarif yang ditetapkan untuk sesi Anda di tiap outlet.",
        loading: "Memuat harga...",
        loadFailed: "Harga tidak dapat dimuat. Silakan coba lagi.",
        readOnlyNote: "Harga ditetapkan oleh merchant. Hubungi mereka untuk mengubah tarif.",
        stats: {
            outlets: "Outlet",
            activePrices: "Tarif aktif",
            serviceTypes: "Jenis layanan",
        },
        column: {
            outlet: "Outlet",
            sport: "Olahraga",
            serviceType: "Jenis layanan",
            basis: "Basis",
            price: "Harga",
            status: "Status",
            effective: "Periode berlaku",
        },
        basis: {
            flat_per_booking: "Flat per booking",
            hourly: "Per jam",
        },
        serviceType: {
            venue_booking: "Booking Venue",
            venue_booking_add_on: "Add-on Booking Venue",
            membership: "Membership",
        },
        status: {
            active: "Aktif",
            inactive: "Nonaktif",
        },
        empty: {
            title: "Belum ada harga",
            description: "Setelah merchant menetapkan tarif Anda, akan muncul di sini.",
        },
    },
    payroll: {
        title: "Payroll",
        subtitle: "Estimasi penghasilan coaching Anda per bulan.",
        loading: "Memuat payroll...",
        loadFailed: "Payroll tidak dapat dimuat. Silakan coba lagi.",
        disclaimer: "Ini estimasi — slip gaji final diterbitkan oleh merchant Anda.",
        stats: {
            total: "Total estimasi",
            sessions: "Sesi layak bayar",
            hours: "Jam mengajar",
        },
        month: {
            label: "Bulan",
            prev: "Bulan sebelumnya",
            next: "Bulan berikutnya",
        },
        tableTitle: "Rincian per outlet",
        column: {
            outlet: "Outlet",
            sessions: "Sesi",
            hours: "Jam",
            rate: "Tarif",
            basis: "Basis",
            estimate: "Estimasi",
            note: "Catatan",
        },
        noDaily: "Tidak ada data sesi berbayar untuk bulan ini.",
        basis: {
            flat_per_session: "Flat per sesi",
            hourly: "Per jam",
            monthly: "Bulanan",
            per_pax: "Per peserta",
            revenue_share: "Bagi hasil",
        },
        notes: {
            no_contract: "Tidak ada kontrak aktif untuk outlet ini bulan ini.",
            rate_missing: "Kontrak tidak memiliki tarif untuk basisnya.",
            basis_unknown: "Basis (per peserta / bagi hasil) tidak dapat dihitung di sini.",
        },
        empty: {
            title: "Tidak ada sesi bulan ini",
            description: "Penugasan yang pembayarannya dikonfirmasi akan muncul di sini.",
        },
    },
    auth: {
        subtitle: "Masuk untuk melihat jadwal coaching Anda",
        heroEyebrow: "Portal khusus coach",
        heroTitleA: "Karier Melatih Lebih",
        heroTitleB: "Mudah Bersama.",
        heroDesc:
            "Gabung Flexv, atur jadwal sesukamu, ambil sesi yang cocok, dan bangun reputasi sebagai coach andalan.",
        heroCta: "Kamu belum daftar?",
        heroCtaButton: "Daftar Sekarang",
        identifier: "Email atau Nama Pengguna",
        password: "Kata Sandi",
        signIn: "Masuk",
        demoAccount: "Akun demo",
        signInFailed: "Tidak dapat masuk. Silakan coba lagi.",
        invalidCredentials: "Email/username/nomor HP atau kata sandi salah. Periksa lagi.",
        accountInactive: "Akun ini tidak aktif. Hubungi support.",
        sessionExpired: "Sesi berakhir. Silakan masuk lagi.",
        googleInvalid: "Sesi Google kedaluwarsa. Coba login Google lagi.",
        googleDifferent: "Akun ini sudah terhubung ke akun Google lain.",
        networkFailed: "Gangguan jaringan. Periksa koneksi lalu coba lagi.",
        checkEmailCode: "Akunmu belum terverifikasi. Kami kirim kode baru ke {email}.",
        or: "atau",
        googleSignIn: "Lanjutkan dengan Google",
        googleSignInFailed: "Login Google tidak dapat diselesaikan. Silakan coba lagi.",
        restoring: "Memulihkan sesi Anda...",
        noAccount: "Coach baru?",
        createAccount: "Daftar akun",
        signup: {
            subtitle: "Lengkapi data diri untuk membuat akun coach",
            fullName: "Nama Lengkap",
            fullNamePlaceholder: "Nama sesuai identitas",
            phone: "Nomor HP",
            phonePlaceholder: "0812xxxxxxx",
            email: "Email",
            emailPlaceholder: "coach@flexv.my.id",
            password: "Kata Sandi",
            passwordHint: "Min. 8 karakter, maks. 128 karakter",
            confirmPassword: "Konfirmasi Kata Sandi",
            submit: "Daftar",
            haveAccount: "Sudah punya akun?",
            backToSignIn: "Masuk",
            failed: "Pendaftaran tidak dapat diselesaikan. Silakan coba lagi.",
            fullNameInvalid: "Isi nama lengkap (min. 2 karakter).",
            phoneInvalid: "Isi nomor HP yang valid (7–14 digit setelah kode negara).",
            emailInvalid: "Isi alamat email yang valid.",
            passwordTooShort: "Kata sandi minimal 8 karakter.",
            passwordMismatch: "Konfirmasi kata sandi tidak cocok.",
            emailTaken: "Email ini sudah terdaftar. Coba masuk saja.",
            phoneTaken: "Nomor HP ini sudah terdaftar. Coba masuk saja.",
            accountTaken: "Email atau nomor HP ini sudah terdaftar.",
            googleInvalid: "Sesi Google kedaluwarsa. Kembali lalu ketuk Lanjutkan dengan Google lagi.",
            googleMismatch: "Email akun Google tidak sama dengan email yang kamu ketik.",
            googleLinkedOther: "Akun Google ini sudah terhubung ke coach lain.",
            googleLinkedNote: "Akun Google ini akan terhubung setelah pendaftaran selesai.",
            otpSent: "Akun dibuat! Kami kirim kode 6 digit ke {email}.",
        },
        verify: {
            title: "Verifikasi email",
            subtitle: "Masukkan kode 6 digit yang kami kirim ke email Anda.",
            email: "Email",
            code: "Kode verifikasi",
            codeHint: "6 digit, berlaku 10 menit",
            emailRequired: "Masukkan alamat email Anda.",
            codeInvalid: "Isi kode 6 digit.",
            submit: "Verifikasi",
            resend: "Kirim ulang kode",
            resendCooldown: "Kirim ulang dalam {s} dtk",
            resent: "Kode baru telah dikirim ke email Anda.",
            backToLogin: "Kembali ke login",
            failed: "Verifikasi tidak dapat diselesaikan. Silakan coba lagi.",
            invalidCode: "Kode salah. Cek email terbaru lalu coba lagi.",
            expired: "Kode kedaluwarsa. Ketuk Kirim ulang kode.",
            locked: "Terlalu banyak salah coba. Tunggu 15 menit atau ketuk Kirim ulang.",
            tooFast: "Tunggu {s} dtk sebelum minta kode baru.",
            noAccount: "Tidak ada akun untuk email ini. Daftar dulu.",
            alreadyVerified: "Email sudah terverifikasi. Silakan masuk.",
            sessionLost: "Email terverifikasi! Sesi habis — silakan masuk lagi.",
            verifiedOk: "Email terverifikasi! Masuk otomatis…",
            sendFailed: "Gagal kirim email. Cek alamat atau ketuk Kirim ulang.",
        },
    },
};
